import script from "./CollectionList.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionList.vue?vue&type=script&setup=true&lang=js"

import "./CollectionList.vue?vue&type=style&index=0&id=171646dd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-171646dd"]])

export default __exports__